import { el, group } from "./dom";

// The top-bar A–B loop controls (set-A / set-B / clear + the range readout), extracted
// from controls.ts to keep that glue file under the size cap. Build the buttons wired to
// the loop handlers, expose the group element for the bar, and reflect the active range.

interface LoopHandlers {
  onLoopSet(which: "a" | "b"): void;
  onLoopClear(): void;
}

interface LoopControls {
  /** The "Loop" group element to splice into the top bar. */
  group: HTMLElement;
  /** Reflect the active loop range (null/null ⇒ no loop). */
  setLoop(start: number | null, end: number | null): void;
}

export function buildLoopControls(handlers: LoopHandlers): LoopControls {
  const loopA = el<HTMLButtonElement>("button", {
    textContent: "A",
    title: "Loop start at playhead",
  });
  loopA.onclick = () => handlers.onLoopSet("a");
  const loopB = el<HTMLButtonElement>("button", {
    textContent: "B",
    title: "Loop end at playhead",
  });
  loopB.onclick = () => handlers.onLoopSet("b");
  const loopClear = el<HTMLButtonElement>("button", { textContent: "✕", title: "Clear loop" });
  loopClear.onclick = () => handlers.onLoopClear();
  const loopLabel = el<HTMLSpanElement>("span", { textContent: "—" });
  return {
    group: group("Loop", loopA, loopB, loopClear, loopLabel),
    setLoop: (start, end) => {
      const fmt = (x: number | null) => (x === null ? "·" : `${x.toFixed(1)}s`);
      loopLabel.textContent = start === null && end === null ? "—" : `${fmt(start)}–${fmt(end)}`;
    },
  };
}
